(function () {
    const items = Array.from(document.querySelectorAll(".faq-item"));

    if (!items.length) return;

    function setItemOpen(item, open) {
        item.classList.toggle("is-open", open);
        const toggle = item.querySelector(".faq-toggle");
        if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
    }

    items.forEach((item) => {
        const toggle = item.querySelector(".faq-toggle");
        if (!toggle) return;

        toggle.addEventListener("click", () => {
            const wasOpen = item.classList.contains("is-open");
            items.forEach((other) => setItemOpen(other, false));
            setItemOpen(item, !wasOpen);
        });
    });
})();
